import React from 'react';
import { useTranslation } from 'react-i18next';
import { SymbolDetailLabeledValue } from '../../../../symbol-detail/labeled-value/symbol-detail-labeled-value';
import { ValueAmount } from '../../../../value/amount/value-amount';
import { ValuePercents } from '../../../../value/percents/value-precents';

interface FairPriceTabFcfStatsProps {
    currency: string;
    fcfPerShare: number | null;
    fcfYield: number | null;
}

export const FairPriceTabFcfStats: React.FC<FairPriceTabFcfStatsProps> = ({ currency, fcfPerShare, fcfYield }) => {
    const { t } = useTranslation();

    return (
        <div className="mb-medium rounded-medium border border-border px-small pb-small pt-medium">
            <div className="mb-medium text-[2.4rem] font-bold leading-[3.2rem] text-brand-secondary">
                {t('layout.dialogs.fairPrice.fcf.defaultValues')}
            </div>
            <div className="grid gap-y-small gap-x-vlarge sm:grid-cols-2">
                <div>
                    <SymbolDetailLabeledValue
                        label={t('layout.dialogs.fairPrice.fcf.fcfPerShareTTM')}
                        value={
                            fcfPerShare !== null ? (
                                <ValueAmount mode="pure" amount={fcfPerShare} currency={currency} fractionDigits={2} />
                            ) : (
                                '—'
                            )
                        }
                    />
                </div>
                <div>
                    <SymbolDetailLabeledValue
                        label={t('layout.dialogs.fairPrice.fcf.fcfYieldTTM')}
                        value={
                            fcfYield !== null ? <ValuePercents mode="pure" amount={fcfYield} fractionDigits={2} /> : '—'
                        }
                    />
                </div>
            </div>
        </div>
    );
};
